module.exports = __webpack_public_path__ + "img/top-function-report-audience.3760451e.jpg";